/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbExportDto
 */
export interface FcbExportDto {
    /**
     * 
     * @type {number}
     * @memberof FcbExportDto
     */
    idexport?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbExportDto
     */
    iddb?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbExportDto
     */
    idtype?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbExportDto
     */
    query?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbExportDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbExportDto
     */
    nom?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbExportDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbExportDto interface.
 */
export function instanceOfFcbExportDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExportDtoFromJSON(json: any): FcbExportDto {
    return FcbExportDtoFromJSONTyped(json, false);
}

export function FcbExportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idexport': !exists(json, 'idexport') ? undefined : json['idexport'],
        'iddb': !exists(json, 'iddb') ? undefined : json['iddb'],
        'idtype': !exists(json, 'idtype') ? undefined : json['idtype'],
        'query': !exists(json, 'query') ? undefined : json['query'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbExportDtoToJSON(value?: FcbExportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idexport': value.idexport,
        'iddb': value.iddb,
        'idtype': value.idtype,
        'query': value.query,
        'description': value.description,
        'nom': value.nom,
        'actif': value.actif,
    };
}

